(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dang-frame-guide"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('dang-frame-guide')) {
  customElements.define('dang-frame-guide', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      this.querySelector('[data-controls]').hidden = false;
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-model]');
        if (!button || !this.contains(button)) return;
        const model = button.dataset.model;
        this.querySelectorAll('[data-model]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
        this.querySelectorAll('[data-photo]').forEach(item => { item.hidden = item.dataset.photo !== model; });
        this.querySelector('[data-status]').textContent = button.dataset.message;
      }, { signal: this.controller.signal });
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
